import React, { useEffect } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';
import { useAccountsFields, useNavigate } from '@utils/hooks';

import { useStore, accountsActions } from '@modules';

import AccountsExclamation from '@components/AccountsExclamation';
import AccountDetails from '@containers/AccountDetails';
import LoaderLayout from '@layouts/LoaderLayout';
import MainLayout from '@layouts/MainLayout';

import style from './AccountsDetails.scss';

const cn = bemCssModules(style, 'AccountsDetails');
const ti = getTestId('AccountDetails');

export type TAccountsDetails = {
  className?: string;
};

const AccountsDetails: CustomFC<TAccountsDetails> = ({ className }) => {
  const { t } = useTranslation();

  const navigate = useNavigate();
  const [{ accounts }, dispatch] = useStore();
  const { details, loaders } = accounts;

  const account = details[0];
  const { fullName, iban, swiftCode, countryOfResidence, city, address } =
    useAccountsFields(account);

  const fields = [fullName, iban, swiftCode, countryOfResidence, city, address];

  useEffect(() => {
    dispatch(accountsActions.getAccounts());
  }, []);

  const isLoading = loaders.getAccounts;

  const onBack = () => navigate(CONST.nav.accounts);

  return (
    <MainLayout className={cn(null, [className])} backButton={onBack}>
      <LoaderLayout isLoading={isLoading}>
        <div className={cn('content')}>
          <div className={cn('header')} data-testid={ti('header')}>
            {' '}
            {t('iban.account_details.title')}
          </div>
          <AccountsExclamation className={cn('exclamation')} data-testid={ti('exclamation')} />
          <AccountDetails fields={fields} />
        </div>
      </LoaderLayout>
    </MainLayout>
  );
};

export default AccountsDetails;
